import { ADS_ENABLED } from './google-ads'

let isBlocked = false
let isLoaded = false
const listeners = new Set<(status: { isBlocked: boolean; isLoaded: boolean }) => void>()

export function getExoclickStatus() {
  return { isBlocked, isLoaded }
}

export function subscribeToExoclickStatus(listener: (status: { isBlocked: boolean; isLoaded: boolean }) => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

function notify() {
  for (const listener of listeners) {
    listener({ isBlocked, isLoaded })
  }
}

// Centralized Exoclick status tracking
export function ensureExoclickScript() {
  if (!ADS_ENABLED || typeof document === 'undefined') {
    isBlocked = true
    return
  }

  const scriptId = 'exoclick-ad-provider'
  if (document.getElementById(scriptId)) {
    return
  }

  const script = document.createElement('script')
  script.id = scriptId
  script.async = true
  script.type = 'application/javascript'
  script.src = 'https://a.magsrv.com/ad-provider.js'
  script.onload = () => {
    isLoaded = true
    notify()
  }
  script.onerror = () => {
    isBlocked = true
    notify()
  }
  document.head.appendChild(script)
}
